import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HseTabBar } from "./HseTabBar";

export const HSE_EVENT_TABS = [
  { id: "all", path: "/dashboard/hse-ks/events", labelKey: "hse.events.tab.all" },
  {
    id: "deviations",
    path: "/dashboard/hse-ks/events/deviations",
    labelKey: "hse.events.tab.deviations",
  },
  {
    id: "near-misses",
    path: "/dashboard/hse-ks/events/near-misses",
    labelKey: "hse.events.tab.near_misses",
  },
  {
    id: "accidents",
    path: "/dashboard/hse-ks/events/accidents",
    labelKey: "hse.events.tab.accidents",
  },
  {
    id: "complaints",
    path: "/dashboard/hse-ks/events/complaints",
    labelKey: "hse.events.tab.complaints",
  },
  {
    id: "observations",
    path: "/dashboard/hse-ks/events/observations",
    labelKey: "hse.events.tab.observations",
  },
];

export function detectEventTab(pathname = "") {
  if (pathname.includes("/deviations")) return "deviations";
  if (pathname.includes("/near-misses")) return "near-misses";
  if (pathname.includes("/accidents")) return "accidents";
  if (pathname.includes("/complaints")) return "complaints";
  if (pathname.includes("/observations")) return "observations";
  return "all";
}

export function EventSubnav({ active }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const activeId = active || detectEventTab(location.pathname);

  return (
    <HseTabBar
      tabs={HSE_EVENT_TABS.map((tab) => ({
        id: tab.id,
        label: t(tab.labelKey),
        path: tab.path,
      }))}
      activeId={activeId}
      onSelect={(tab) => navigate(tab.path)}
      ariaLabel={t("hse.events.nav.aria")}
    />
  );
}
